import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import LevelGraphStructure from "../GraphStructure/LevelGraphStructure";
import { getDashboardQueryParams, getLocalizedMessage } from "../../../../UtilityFunctions/utils";
import variables from "../../../../themes/base/styles/variables";
import { OneRow } from "../../../../core/layouts";
import {
  getCountLevel,
  setLevel3Graph,
} from "../../../../globalContext/dashboard/dashboardActions";
import DashboardService from "../../../../services/dashboard-service";
import { DashboardContext } from "../../../../globalContext/dashboard/dashboardProvider";
import { BAD_REQUEST } from "../../../../constants/errorConstants";
import { GlobalLoaderContext } from "../../../../globalContext/globalLoader/globalLoaderProvider";
import { userRole } from "../../../../constants";
import { AuthContext } from "../../../../globalContext/auth/authProvider";

const Level3 = ({ filter }) => {
  const intl = useIntl();
  const [dashboardState, dashboardDispatch] = useContext(DashboardContext);
  const [level3Data, setLevel3Data] = useState([]);
  const [checked, setChecked] = useState(false);
  const [dataNotFound, setDataNotFound] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const [authState] = useContext(AuthContext);

  useEffect(() => {
    setIsLoading(true);
    let params = getDashboardQueryParams(filter);
    delete params.isPercentage;
    if (
      !params.year ||
      (params.type === "Repair" && !params.subProductCategoryId) ||
      (authState?.currentRole?.id === userRole.ADMIN && !params.countryId) ||
      !params.type
    ) {
      setDataNotFound(
        getLocalizedMessage(
          intl,
          authState?.currentRole?.id !== userRole.ADMIN
            ? "selectCategories.CA.TM.label"
            : "selectCategories.label"
        )
      );
    } else {
      if (dataNotFound) {
        setDataNotFound("");
      }
      DashboardService.getCountLevelApiCall({
        dispatch: dashboardDispatch,
        intl,
        params: {
          ...params,
          level: 3,
        },
        action: getCountLevel,
      })
        .then((data) => {
          dashboardDispatch(setLevel3Graph(data.data));
        })
        .catch((error) => {
          if (error?.response?.data?.code === BAD_REQUEST) {
            setDataNotFound(
              getLocalizedMessage(intl, "dataNotAvailable.label")
            );
          }
        });
    }
    setIsLoading(false);
  }, [filter]);

  useEffect(() => {
    if (dashboardState.level3.result) {
      const newData = dashboardState?.level3?.result?.map((item, index) => ({
        name: dashboardState.level3.result[index].sectionName,
        okCount: dashboardState.level3.result[index].okCount,
        questionCount: dashboardState.level3.result[index].questionCount,
        percentage: dashboardState.level3.result[index].percentage,
      }));
      setLevel3Data(newData);
    }
  }, [dashboardState]);

  useEffect(() => {
    setIsLoading(true);
    if (checked) {
      const convertedData = level3Data?.map((item) => {
        return {
          ...item,
          percentage: (item.okCount / item.questionCount) * 100,
          okCount: item.percentage,
          questionCount: 100,
        };
      });
      setLevel3Data(convertedData);
    } else {
      const newData = dashboardState?.level3?.result?.map((item, index) => ({
        name: dashboardState.level3.result[index].sectionName,
        okCount: dashboardState.level3.result[index].okCount,
        questionCount: dashboardState.level3.result[index].questionCount,
        percentage: dashboardState.level3.result[index].percentage,
      }));
      setLevel3Data(newData);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [checked]);

  const modifiedData = level3Data?.map((item) => {
    return {
      ...item,
      remainingCount: item.questionCount - item.okCount,
    };
  });

  const downloadUserReportsHandler = () => {
    let queryParams = getDashboardQueryParams(filter);
    delete queryParams.isPercentage;
    DashboardService.dashboardDownloadReportApiCall({
      params: {
        ...queryParams,
        fileName: getLocalizedMessage(intl, "dashboard.level3.label"),
        reportType: getLocalizedMessage(intl, "levelReport.label"),
        level: 3,
      },
      intl,
      loaderDispatch: loaderDispatch,
    });
  };

  return (
    <OneRow
      id="level3-graph"
      section={
        <LevelGraphStructure
          dataNotFound={dataNotFound}
          setDataNotFound={setDataNotFound}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          data={modifiedData}
          legend1={getLocalizedMessage(intl, "levelGraphs.legend1.label")}
          legend2={getLocalizedMessage(intl, "levelGraphs.legend2.label")}
          dataKey1={getLocalizedMessage(intl, "remainingCount.label")}
          dataKey2={getLocalizedMessage(intl, "okCount.label")}
          dataKey3={getLocalizedMessage(intl, "name.label")}
          dataKey4="questionCount"
          checked={checked}
          setChecked={setChecked}
          downloadUserReportsHandler={downloadUserReportsHandler}
          labelText={getLocalizedMessage(intl, "dashboard.level3.label")}
          text1={getLocalizedMessage(intl, "levelGraph.payload.value1")}
          text2={getLocalizedMessage(intl, "levelGraph.payload.value2")}
          linkLabel={getLocalizedMessage(intl, "level3.link.label")}
          background={{ fill: `${variables.lightBlue}` }}
          color1={variables.cerulean}
          color2={variables.lightBlue3}
          isPercentageChecked={checked}
          level={"LEVEL3"}
          graphId="level3-graph"
        />
      }
    />
  );
};

export default Level3;
